<div class="kd-document-snippet snippet" [ngClass]="{
    'snippet--error': error
}">
    <div *ngIf="error" class="error">
        {{error}}
    </div>

    <div *ngIf="!error" class="langs">
        <div *ngFor="let lang of langs" class="lang" [ngClass]="{
            'lang--selected': isLangSelected(lang)
        }">
            <span *ngIf="isLangSelected(lang)">{{lang.name}}</span>

            <a
                *ngIf="!isLangSelected(lang)"
                class="lang-link"
                (click)="selectLang(lang)"
            >
                {{lang.name}}
            </a>
        </div>
    </div>
    
    <pre *ngIf="error" class="content" [innerHTML]="element.innerHTML"></pre>

    <pre
        *ngIf="!error"
        class="content"
        [ngClass]="lang.syntax"
    ></pre>

    <div *ngIf="spinner" class="spinner"></div>
</div>
